/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class SubjectRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let thisYear = moment().year();
    let lastYear = thisYear - 1;
    let group = this.modelFor('group');

    return hash({
      group,
      learners: this.modelFor('group.insights').learners,
      thisYear: this.store.query('date', {
        year: thisYear,
      }),
      lastYear: this.store.query('date', {
        year: lastYear,
      }),
      subject: this.store.findRecord('goals/subject', params.subject_id),
      levels: this.store.query('milestones/level', {
        goalSubjectId: params.subject_id,
      }),
      progressions: this.store.query('milestones/progression', {
        groupId: group.id,
        latest: true,
        type: ProgressionType.PROGRESSION,
        goalSubjectId: params.subject_id,
      }),
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    this.controllerFor('group/insights/progress').setProperties({
      subjectId: model.subject.id,
      report: 'rates',
    });
  }
}
